export default {
  BOOKING: 'booking',
  BOOKING_ARRIVAL: 'bookingArrival',
  ARRIVAL: 'arrival',
};



// WEBPACK FOOTER //
// ./src/variables/ski/pass/sales-type-enums.js